import { render, staticRenderFns } from "./SendSMS.vue?vue&type=template&id=39cbf0b5&"
import script from "./SendSMS.vue?vue&type=script&lang=js&"
export * from "./SendSMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports